<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
   <div class="tile" [class.tile--editing]="isEditing" [class.tile--fullscreen]="isFullscreen">
      @if (showHeader) {
      <div class="tile_header" [style.border-bottom-color]="tileConfig.dashboardTileLayoutConfiguration.color">
         <div class="tile_name">
            <ng-content select="[tileheadername]"></ng-content>
         </div>
         <div class="tile_actions">
            <ng-content select="[moreactions]"></ng-content>
            @if (!isFullscreen) { @if (isEditing) {
            <button
               type="button"
               class="tile_action tile_action--danger"
               (click)="onDeleteTile()"
               matTooltip="Remove tile"
               aria-label="Remove tile"
            >
               <mat-icon>delete_outline</mat-icon>
            </button>
            <button
               type="button"
               class="tile_action"
               (click)="onConfigureParameters()"
               matTooltip="Tile settings"
               aria-label="Tile settings"
            >
               <mat-icon>settings</mat-icon>
            </button>
            } @else { @if (canRefresh) {
            <button
               type="button"
               class="tile_action"
               (click)="onRefreshTile()"
               matTooltip="Refresh"
               aria-label="Refresh tile"
            >
               <mat-icon>refresh</mat-icon>
            </button>
            }
            <button
               type="button"
               class="tile_action"
               (click)="onOpenFullscreen()"
               matTooltip="Expand"
               aria-label="Expand tile"
            >
               <mat-icon>open_in_full</mat-icon>
            </button>
            } } @else {
            <button
               type="button"
               class="tile_action"
               (click)="onCloseFullscreen()"
               matTooltip="Close"
               aria-label="Close fullscreen"
            >
               <mat-icon>close</mat-icon>
            </button>
            }
         </div>
      </div>
      }

      <div class="tile_info" [class.tile_info_readonly]="isEditing">
         <ng-content select="[tileInfo]"></ng-content>
      </div>
   </div>
   <ng-content select="[tileParametersList]"></ng-content>
</lcs-loading-overlay>
